import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/club/check.png'


const _withScopeId = n => (_pushScopeId("data-v-23006c71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal-values" }
const _hoisted_3 = { class: "modal-values-title" }
const _hoisted_4 = { class: "modal-values-content" }
const _hoisted_5 = { class: "value-month" }
const _hoisted_6 = { class: "modal-input-value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "/ month")
], -1))
const _hoisted_8 = { class: "modal-range-section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Chose the quantity you can pay", -1))
const _hoisted_10 = { class: "modal-options" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-benefits\" data-v-23006c71><div class=\"modal-benefit\" data-v-23006c71><img src=\"" + _imports_0 + "\" alt=\"check\" data-v-23006c71><p class=\"benefits-item\" data-v-23006c71>EasyBank Coins every month</p></div><div class=\"modal-benefit\" data-v-23006c71><img src=\"" + _imports_0 + "\" alt=\"check\" data-v-23006c71><p class=\"benefits-item\" data-v-23006c71>20% discount to buy new coins</p></div><div class=\"modal-benefit\" data-v-23006c71><img src=\"" + _imports_0 + "\" alt=\"check\" data-v-23006c71><p class=\"benefits-item\" data-v-23006c71>Email reports</p></div></div>", 1)
const _hoisted_12 = { class: "modal-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonRequest = _resolveComponent("ButtonRequest")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.coinsValue) + "K EasyBank Coins", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, "$" + _toDisplayString(_ctx.inputValue), 1)
        ]),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createElementVNode("input", {
        class: "modal-range",
        type: "range",
        min: "10",
        max: "40",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateRangeValue && _ctx.updateRangeValue(...args)))
      }, null, 544), [
        [_vModelText, _ctx.inputValue]
      ]),
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_ButtonRequest, { text: "Request Invite" })
      ])
    ])
  ]))
}